import axios from 'axios';
import React from 'react';
import Properties from "../const/Properties";
import CustomModal from "../thema/tema1/component/CustomModal";
import Footer from "../thema/tema1/component/Footer";
import Header from "../thema/tema1/component/Header";
import PageContext from "../thema/tema1/component/PageContext";
import SideMenu from "../thema/tema1/component/SideMenu";
import {withRouter} from 'react-router-dom';

const active = {Home: "active"};
const gidecegiUlkeEnum = {
    1: "TRİESTE",
    2: "BARİ",
};
const geldigiGumruk = {
    1: "ESENDERE",
    2: "DİLUCU",
    3: "GÜRBULAK",
};

class BilgiGiris extends React.Component {
    constructor(props) {
        super(props);
        if (localStorage.getItem("token") == "") {
            window.location = '/';
            return false;
        }
        this.state = {
            tasimaId: this.props.match.params.id,
            surucuAdi: "",
            karneNumarasi: "",
            pasaportNumarasi: "",
            geldigiGumruk: "",
            gemiAdi: "",
            muhurNumarasi: "",
            ttNumarasi: "",
            gidecegiUlke: "",
            kapAdeti: 0,
            kg: 0,
            yukCinsi: "",
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            silModal: 'none',
            title: ["STATU", "TARİH", "ÇEKİCİ PLAKA", "İŞLEM ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.get();
    }

    componentDidMount() {

    }

    tasimaSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/tasima/saveEkBilgi',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    surucuAdi: this.state.surucuAdi ? this.state.surucuAdi.toUpperCase() : '',

                    karneNumarasi: this.state.karneNumarasi ? this.state.karneNumarasi.toUpperCase() : '',

                    pasaportNumarasi: this.state.pasaportNumarasi ? this.state.pasaportNumarasi.toUpperCase() : '',

                    geldigiGumruk: this.state.geldigiGumruk ? this.state.geldigiGumruk.toUpperCase() : '',

                    gemiAdi: this.state.gemiAdi ? this.state.gemiAdi.toUpperCase() : '',

                    ttNumarasi: this.state.ttNumarasi ? this.state.ttNumarasi.toUpperCase() : '',

                    kapAdeti: this.state.kapAdeti ? this.state.kapAdeti : '',

                    gidecegiUlke: this.state.gidecegiUlke ? this.state.gidecegiUlke : '',

                    kg: this.state.kg ? this.state.kg : '',

                    yukCinsi: this.state.yukCinsi ? this.state.yukCinsi.toUpperCase() : '',

                    durum: 2,

                    tasimaId: this.state.tasimaId ? this.state.tasimaId : '',

                }
            })
                .then(res => {
                    window.successful((this.state.showDuzenle ? "Ek Bilgi Güncellendi." : "Ek Bilgi Kaydedildi"));
                    this.setState({surucuAdi: ""});
                    this.setState({karneNumarasi: ""});
                    this.setState({pasaportNumarasi: ""});
                    this.setState({geldigiGumruk: ""});
                    this.setState({gidecegiUlke: ""});
                    this.setState({ttNumarasi: ""});
                    this.setState({gemiAdi: ""});
                    this.setState({yukCinsi: ""});
                    this.setState({kapAdeti: 0});
                    this.setState({kg: 0});
                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
            });
            this.geri();
        }
    }
    get = e => {
        let status = true;
        if (status) {
            axios({
                method: 'get',
                url: Properties.baseUrl + '/tasima/get/' + this.state.tasimaId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    this.setState({surucuAdi: res.data.surucuAdi});
                    this.setState({karneNumarasi: res.data.karneNumarasi});
                    this.setState({pasaportNumarasi: res.data.pasaportNumarasi});
                    this.setState({geldigiGumruk: res.data.geldigiGumruk});
                    this.setState({gidecegiUlke: res.data.gidecegiUlke});
                    this.setState({ttNumarasi: res.data.ttNumarasi});
                    this.setState({gemiAdi: res.data.gemiAdi});
                    this.setState({yukCinsi: res.data.yukCinsi});
                    this.setState({kapAdeti: res.data.kapAdeti});
                    this.setState({kg: res.data.kg});
                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
            });
        }
    }
    geri = () => {
        window.history.back();
    }
    onChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }

    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu/>
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-2">
                                        <h3 className="card-title">Ücret Belirle</h3>
                                    </div>
                                </div>

                            </div>
                            <div className="card-body">
                                <div className="col-6" style={{"display":"none"}}>
                                    <label>Gideceği Ülke</label>
                                    <select name="gidecegiUlke" className="form-control select2"
                                            onChange={this.onChange} value={this.state.gidecegiUlke}>
                                        <option value={0} selected="selected">Tür Seç</option>
                                        <option value={1}>TRİESTE</option>
                                        <option value={2}>BARİ</option>
                                    </select>
                                </div>

                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">TT Numarası</label>
                                    <input type="text" className="form-control" name="ttNumarasi"
                                           onChange={this.onChange} value={this.state.ttNumarasi}
                                           placeholder="TT Numarası"/>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">Sürücü Adı</label>
                                    <input type="text" className="form-control" name="surucuAdi"
                                           onChange={this.onChange} value={this.state.surucuAdi}
                                           placeholder="Sürücü Adı"/>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">Karne Numarası</label>
                                    <input type="text" className="form-control" name="karneNumarasi"
                                           onChange={this.onChange} value={this.state.karneNumarasi}
                                           placeholder="Karne Numarası"/>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">Pasaport Numarası</label>
                                    <input type="text" className="form-control" name="pasaportNumarasi"
                                           onChange={this.onChange} value={this.state.pasaportNumarasi}
                                           placeholder="Pasaport Numarası"/>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">Geldiği Gümrük</label>
                                    <select name="geldigiGumruk" className="form-control select2"
                                            onChange={this.onChange} value={this.state.geldigiGumruk}>
                                        <option value={0} selected="selected">Tür Seç</option>
                                        <option value={1}>ESENDERE</option>
                                        <option value={2}>DİLUCU</option>
                                        <option value={3}>GÜRBULAK</option>
                                    </select>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">Gemi Adı</label>
                                    <input type="text" className="form-control" name="gemiAdi" onChange={this.onChange}
                                           value={this.state.gemiAdi}
                                           placeholder="Gemi Adı"/>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">Kap Adeti</label>
                                    <input type="text" className="form-control" name="kapAdeti" onChange={this.onChange}
                                           value={this.state.kapAdeti}
                                           placeholder="Kap Adeti"/>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">KG</label>
                                    <input type="text" className="form-control" name="kg" onChange={this.onChange}
                                           value={this.state.kg}
                                           placeholder="KG"/>
                                </div>
                                <div className="col-6">
                                    <label htmlFor="exampleInputEmail1">Yük Cinsi</label>
                                    <input type="text" className="form-control" name="yukCinsi" onChange={this.onChange}
                                           value={this.state.yukCinsi}
                                           placeholder="Yük Cinsi"/>
                                </div>
                            </div>
                            <div className="card-footer row">
                                <div className="col-1">
                                    <button type="button"
                                            className="btn btn-block btn-primary" data-toggle="modal"
                                            data-target="#modal-default">Kaydet
                                    </button>
                                </div>
                                <div className="col-1">
                                    <button type="button" onClick={e => this.geri(e)}
                                            className="btn btn-block btn-outline-info">GERİ
                                    </button>
                                </div>
                            </div>
                        </div>

                    </form>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.tasimaSave} title={"Ek Bilgi Girişi"}
                             content={"Ek Bilgileri Onaylıyor Musunuz?"}></CustomModal>

            </div>);
    }
}


export default withRouter(BilgiGiris);
